const state = {
  loading: {
    isLoading: false,
    isFullPage: true,
  },
  menuOpen: true,
  isMobile: false,
  notificationsSeen: false,
};

export default state;